import React, { useEffect, useState } from 'react';
import { WebsiteReportSummaryVersionB } from './WebsiteReportSummaryVersionB';
import ReactGA from 'react-ga4';
import { WebsiteReportSummaryVersionA } from './WebsiteReportSummaryVersionA';
import { useWebsiteReportModals } from './use-website-report-modals';

export type LLRReportVersion = 'A' | 'B';

export const WebsiteReport = () => {
  // TODO: Uncomment when we want to run A/B test
  // const random = Math.floor(Math.random() * (100 - 1) + 1);
  // const randomVersion = random < 50 ? 'A' : 'B';
  const { openSignupModal, openEditUrlModal, websiteURL, pathVersion } =
    useWebsiteReportModals();

  const isWhiteLabel = window.location.search.includes('whitelabel');

  const randomVersion = 'A';
  const storageVersion = localStorage.getItem(
    'onboardingReportVersion',
  ) as LLRReportVersion;
  const [version, setVersion] = useState<LLRReportVersion>(
    pathVersion || randomVersion,
  );

  useEffect(() => {
    if (!storageVersion) {
      localStorage.setItem('onboardingReportVersion', randomVersion);
    }
    if (
      storageVersion &&
      (storageVersion.toLocaleLowerCase() === 'a' ||
        storageVersion.toLocaleLowerCase() === 'b')
    ) {
      localStorage.setItem(
        'onboardingReportVersion',
        'B', // storageVersion.toUpperCase(), TODO: Uncomment when we want to run A/B test
      );
    }
    if (
      storageVersion &&
      storageVersion.toLocaleLowerCase() !== 'a' &&
      storageVersion.toLocaleLowerCase() !== 'b'
    ) {
      localStorage.setItem('onboardingReportVersion', 'A');
    }
    ReactGA.set({ page: `/onboarding-report-${version.toUpperCase()}` });
  }, []);

  // Note: on first load capitalized letter gets converted to lowercase, so we need to handle this case as well
  if (['B', 'b'].includes(version)) {
    return (
      <WebsiteReportSummaryVersionB
        version={version}
        setVersion={setVersion}
        websiteURL={websiteURL}
        openSignupModal={openSignupModal}
        openEditUrlModal={openEditUrlModal}
        isWhiteLabel={isWhiteLabel}
      />
    );
  }

  return (
    <WebsiteReportSummaryVersionA
      version={version}
      setVersion={setVersion}
      websiteURL={websiteURL}
      openSignupModal={openSignupModal}
      openEditUrlModal={openEditUrlModal}
      isWhiteLabel={isWhiteLabel}
    />
  );
};
